import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackCrawlerVisit, trackCrawlerAction } from '../utils/googleAnalytics';
import { isCrawler } from '../utils/crawlerDetection';

export const useCrawlerTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const crawlerData = trackCrawlerVisit();
    
    if (crawlerData) {
      const handleScroll = () => {
        const scrollPercentage = Math.round(
          (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100
        );
        
        if (scrollPercentage > 0 && scrollPercentage % 25 === 0) {
          trackCrawlerAction('scroll', {
            scroll_depth: scrollPercentage,
            page_path: location.pathname
          });
        }
      };

      const handleClick = (e) => {
        const target = e.target.closest('a');
        if (target) {
          trackCrawlerAction('link_click', {
            link_url: target.href,
            link_text: target.textContent?.substring(0, 100),
            page_path: location.pathname
          });
        }
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
      document.addEventListener('click', handleClick);

      return () => {
        window.removeEventListener('scroll', handleScroll);
        document.removeEventListener('click', handleClick);
      };
    }
  }, [location]);

  useEffect(() => {
    if (isCrawler()) {
      trackCrawlerAction('page_view', {
        page_path: location.pathname,
        page_search: location.search
      });
    }
  }, [location.pathname, location.search]);
};